import React, { useEffect } from "react";
import { Link } from 'react-router-dom'
import { useAuthContext } from '../backend/UseAuth'
import { useState } from 'react'
import { useSignup } from '../backend/Register'

import { getDoc, collection, doc, getFirestore } from "firebase/firestore";

export default function Lists() {

    const db = getFirestore();
    const { user } = useAuthContext()
    const { logout } = useSignup()
    const handleSubmit = (e) => {
        logout()
    }
    const [Alldocs, setAlldocs] = useState([]);
    const [singleDoc, setSingledoc] = useState([]);

    useEffect(() => {

        getDoc(doc(db, "users", user.uid)).then(docSnap => {
            if (docSnap.exists()) {
                setSingledoc(docSnap.data());
            } else {
                console.log("No such document!");
            }
        })
    }, [])

    return (


        <React.Fragment>
            <div className="overlay"></div>



            <div className="main-body-wrapper d-flex">

                <div className="sidebar-wrapper bg--accent">
                    <div className="sidebar-inner">
                        <ul className="sidebar-menu">
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/contributions" className="sidebar-menu-link"><img src="assets/images/icon/menu1.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/tests" className="sidebar-menu-link"><img src="assets/images/icon/menu2.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/domain" className="sidebar-menu-link"> <img src="assets/images/icon/menu3.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/visualization" className="sidebar-menu-link"> <img src="assets/images/icon/menu4.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/lists" className="sidebar-menu-link"> <img src="assets/images/icon/menu5.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/profile" className="sidebar-menu-link"> <img src="assets/images/icon/menu6.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="main-content">
                    <div className="main-content-inner">

                        <div className="top-menu-wrapper bg-white">
                            <div className="top-menu-inner d-flex flex-wrap gap-2 justify-content-between">
                                <div className="d-sm-block">
                                    <div className="sidebar-toggler fs--20px d-md-none"><i className="fas fa-bars"></i></div>
                                </div>
                                <a href="contributions.html" className="logo"><img src="assets/images/logo.png" alt="logo" /></a>
                                <ul className="top-menu d-flex flex-wrap gap-3">
                                    <li className="top-menu-item">
                                        <a href="#" className="top-menu-link"><i className="fas fa-bell"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <div className="dropdown-header">
                                                    <div className="d-flex flex-wrap justify-content-between pb-2">
                                                        <h6>Notifications</h6>
                                                        <span>Mark all as read</span>
                                                    </div>
                                                    <ul className="notification">
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="top-menu-item">
                                        <a href="#" className="top-menu-link"><i className="fas fa-user"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <ul className="notification">
                                                    <li className="notification-item border-0">
                                                        <div className="d-flex gap-3">
                                                            <div className="notification-item__thumb">
                                                                <i className="fas fa-user"></i>
                                                            </div>
                                                            <div className="notification-item__content">
                                                                {
                                                                    singleDoc.firstname && <h6 className="notification-item__content-name">
                                                                        {singleDoc.firstname + " " + singleDoc.lastname}
                                                                    </h6>
                                                                }
                                                                <p>Admin</p>
                                                                {
                                                                    <Link to="/profile" className="mt-3 d-block fs--14px fw-semibold">Edit Profile
                                                                    </Link>
                                                                }
                                                                {
                                                                    <Link to="/" onClick={handleSubmit} className="mt-1 d-block fs--14px fw-semibold text--danger">  Log Out
                                                                    </Link>
                                                                }
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="main-content-inner-inner">
                            <div className="card custom--card">
                                <div className="card-header pb-0 d-flex flex-wrap gap-3 justify-content-between align-items-start">
                                    <div className="card-header__left">
                                        <h4 className="title">Lists</h4>
                                        <ul className="nav-tabs nav filter mt-2">
                                            <li className="nav-item"><a href="#languages" className="nav-link active" data-bs-toggle="tab">Languages</a></li>
                                            <li className="nav-item"><a href="#validators" className="nav-link" data-bs-toggle="tab">Validators</a></li>
                                        </ul>
                                    </div>
                                    <button className="btn btn--success two-buttons addLanguageModal show-btn" data-bs-toggle="modal" data-bs-target="#addLanguageModal" >Add Language</button>
                                    <button className="btn btn--success two-buttons addValidatorModal" data-bs-toggle="modal" data-bs-target="#addValidatorModal" >Add Validator</button>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex flex-wrap justify-content-between gap-3 mb-4">
                                        <div className="search-wrapper">
                                            <form action="">
                                                <div className="form-group">
                                                    <input type="text" className="form-control form--control ps-5" />
                                                    <button className="btn fs--18px border-0 btn--icon" type="submit"><i className="fas fa-search"></i></button>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="d-flex flex-wrap gap-3">
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="languages">
                                            <table className="table table--responsive--xl">
                                                <thead>
                                                    <tr>
                                                        <th>Language</th>
                                                        <th>Description</th>
                                                        <th>Stuff</th>
                                                        <th>Edit</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button className="btn btn--warning btn--icon"><i className="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-trash"></i></button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="tab-pane fade" id="validators">
                                            <table className="table table--responsive--xl">
                                                <thead>
                                                    <tr>
                                                        <th>Username</th>
                                                        <th>First Name</th>
                                                        <th>Last Name</th>
                                                        <th>Email</th>
                                                        <th>Additional Information</th>
                                                        <th>Approved by</th>
                                                        <th>Remove</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td data-label="Username">Admin1</td>
                                                        <td data-label="First Name">Depok</td>
                                                        <td data-label="Last Name">Admin1</td>
                                                        <td data-label="Email">DapokAdmin1@gmail.com</td>
                                                        <td data-label="Additional Information">
                                                            <div className="position-relative d-inline-block">
                                                                <a href="#" className="btn btn--md btn--base dropdown-hover">JSmith1 <i className="las la-angle-down"></i></a>
                                                                <div className="dropdown-wrapper">
                                                                    <div className="dropdown-inner">
                                                                        <ul className="list list-simple">
                                                                            <li className="d-flex justify-content-between">
                                                                                <span className="fw-semibold text-start">Education</span>
                                                                                <span className="text-end">Secondary</span>
                                                                            </li>
                                                                            <li className="d-flex justify-content-between">
                                                                                <span className="fw-semibold text-start">Spoken Language(s)</span>
                                                                                <span className="text-end">Filipino, Cebuano</span>
                                                                            </li>
                                                                            <li className="d-flex justify-content-between">
                                                                                <span className="fw-semibold text-start">Fluency</span>
                                                                                <span className="text-end">Native</span>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td data-label="Approved by">Admin1</td>
                                                        <td data-label="Remove"><button className="btn btn--danger btn--icon remove-item"><i className="fas fa-minus-circle"></i></button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="addLanguageModal" tabIndex="-1" aria-labelledby="addLanguageModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content border-0">
                        <div className="modal-body">
                            <form action="">
                                <h4 className="title mb-4 pb-lg-2">Add Language</h4>
                                <input type="text" className="form-control form--control mb-3" placeholder="Language" />
                                <textarea name="" id="" cols="30" rows="10" className="form-control form--control" placeholder="Description"></textarea>
                                <div className="d-flex flex-wrap justify-content-end mt-4">
                                    <button type="submit" className="btn btn--success">Add</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="addValidatorModal" tabIndex="-1" aria-labelledby="addValidatorModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0">
                        <div className="modal-body p-0">
                            <div className="card custom--card card--md border-0 rounded-3">
                                <div className="card-header">
                                    <h4 className="title mb-3">Add Validator</h4>
                                    <div className="search-wrapper">
                                        <form action="">
                                            <div className="form-group">
                                                <input type="text" className="form-control form--control ps-5" />
                                                <button className="btn fs--18px border-0 btn--icon" type="submit"><i className="fas fa-search"></i></button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex align-items-center gap-3 user-item border-bottom pb-3 mb-3">
                                        <div className="user-item__thumb">
                                            <img src="assets/images/user/user.png" alt="" />
                                        </div>
                                        <div className="user-item__content">
                                            <h6 className="user-item__content-name">Nadine Lustre</h6>
                                            <p>@nadielus</p>
                                        </div>
                                        <div className="user-level">
                                            <h4 className="level">1</h4>
                                            <span className="text">level</span>
                                        </div>
                                    </div>
                                    <ul className="list list-simple">
                                        <li className="d-flex justify-content-between">
                                            <span className="fw-semibold text-start">Education</span>
                                            <span className="text-end">Secondary</span>
                                        </li>
                                        <li className="d-flex justify-content-between">
                                            <span className="fw-semibold text-start">Spoken Language(s)</span>
                                            <span className="text-end">Filipino, Cebuano</span>
                                        </li>
                                        <li className="d-flex justify-content-between">
                                            <span className="fw-semibold text-start">Fluency</span>
                                            <span className="text-end">Native</span>
                                        </li>
                                    </ul>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn--success mt-3 mt-sm-4">Add</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}